import React from 'react';
import SectionItem from './SectionItem';
import { useQuiz } from '../../../../contexts/QuizContext';

const SectionNavigation = () => {
  const { quizSections, visibleSections, activeSection, setActiveSection } =
    useQuiz();

  return (
    <div className="lg:col-span-1 sticky top-5.5 z-1">
      <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-4">
        Form Sections
      </h3>

      <div className="space-y-2">
        {(visibleSections || []).map((section, idx) => {
          const sid =
            section.id || section.sectionId || section?.metadata?.sectionId;
          // Map back to original index in full quizSections to keep indices stable
          const originalIndex = (quizSections || []).findIndex(
            s => (s.id || s.sectionId || s?.metadata?.sectionId) === sid
          );
          const index = originalIndex >= 0 ? originalIndex : idx;
          return (
            <SectionItem
              key={sid || idx}
              section={section}
              index={index}
              activeSection={activeSection}
              setActiveSection={setActiveSection}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SectionNavigation;
